import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { AppLayout, Sidebar } from '../ds';
import { useAuth } from '../../context/AuthContext';

const IconAds = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="14" height="14" rx="2"/><path d="M7 7h6M7 10h4"/>
  </svg>
);

const IconMembers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconSettings = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/>
    <line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/>
    <line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>
  </svg>
);

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const companyName = localStorage.getItem('portal_company_name') || 'Portal';

  const handleLogout = async () => {
    try {
      await logout();
      sessionStorage.removeItem('portal_company_id');
      localStorage.removeItem('portal_company_name');
    } catch (e) { /* ignore */ }
  };

  const pageTitle = location.pathname.startsWith('/ads/create') ? 'Create Ad'
    : location.pathname.startsWith('/management') ? '管理'
    : location.pathname.startsWith('/ads') ? 'Ads'
    : '';

  return (
    <AppLayout
      sidebar={
        <Sidebar logo="VMFIVE" subtitle={companyName} footer={
          <button
            onClick={handleLogout}
            style={{
              width: '100%', padding: '6px 16px', background: 'none',
              border: '1px solid rgba(255,255,255,0.2)', color: '#fff',
              borderRadius: 4, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Logout
          </button>
        }>
          <Sidebar.Group title="Ads">
            <NavLink to="/ads" end style={{ textDecoration: 'none' }}>
              {({ isActive }) => <Sidebar.Item icon={<IconAds />} label="All Ads" active={isActive} />}
            </NavLink>
          </Sidebar.Group>
          <Sidebar.Group title="管理">
            <NavLink to="/management/passback" style={{ textDecoration: 'none' }}>
              {({ isActive }) => <Sidebar.Item icon={<IconSettings />} label="Passback 設定" active={isActive} />}
            </NavLink>
            {user?.role === 'admin' && (
              <NavLink to="/management/members" style={{ textDecoration: 'none' }}>
                {({ isActive }) => <Sidebar.Item icon={<IconMembers />} label="成員管理" active={isActive} />}
              </NavLink>
            )}
          </Sidebar.Group>
        </Sidebar>
      }
      header={<h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{pageTitle}</h2>}
    >
      <Outlet />
    </AppLayout>
  );
}
